import { render, staticRenderFns } from "./TriggerManagement.vue?vue&type=template&id=08202924&scoped=true"
import script from "./TriggerManagement.vue?vue&type=script&lang=js"
export * from "./TriggerManagement.vue?vue&type=script&lang=js"
import style0 from "./TriggerManagement.vue?vue&type=style&index=0&id=08202924&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08202924",
  null
  
)

export default component.exports